/**
 * Created by RSchweber-Koren on 4/11/2017.
 */

class TbAppConfigError extends Error {
    constructor(msg, errorData) {
        super(msg);
        this.name = "TbAppConfigError";
        this.errorData = errorData;
    }
}

export default TbAppConfigError;


//////////////////
// WEBPACK FOOTER
// ./src/config/tb-app-config/TbAppConfigError.js
// module id = w2st
// module chunks = 1